/* Product demonstrations start only through an explicit shopper action. */
(() => {
  if (window.JJProductInspection) return;
  window.JJProductInspection = true;
  const init = () => {
    document.querySelectorAll('[data-jj-film]').forEach((frame) => {
      if (frame.dataset.bound) return;
      frame.dataset.bound = 'true';
      const video = frame.querySelector('video');
      const play = frame.querySelector('[data-jj-film-play]');
      if (!video || !play) return;
      const compact = Boolean(frame.closest('.ju-clarity, .jh-clarity, .jj-starter-ceramic'));
      if (compact) video.controls = false;
      play.hidden = false;
      play.addEventListener('click', () => {
        video.controls = true;
        video.play().catch(() => { play.hidden = false; if (compact) video.controls = false; });
      });
      video.addEventListener('play', () => { play.hidden = true; });
      video.addEventListener('ended', () => { play.hidden = false; if (frame.closest('.jj-starter-ceramic')) video.controls = false; });
      video.addEventListener('error', () => { play.hidden = true; });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          entries.forEach((entry) => { if (!entry.isIntersecting) video.pause(); });
        }, { threshold: 0.05 }).observe(video);
      }
    });
    document.querySelectorAll('[data-jj-inspection]').forEach((viewer) => {
      if (viewer.dataset.bound) return;
      viewer.dataset.bound = 'true';
      viewer.querySelectorAll('[data-jj-view]').forEach((button) => {
        button.addEventListener('click', () => {
          viewer.querySelectorAll('[data-jj-view]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
          viewer.querySelectorAll('[data-jj-view-panel]').forEach((panel) => {
            panel.hidden = panel.id !== button.getAttribute('aria-controls');
            if (panel.hidden) panel.querySelectorAll('video').forEach((video) => video.pause());
          });
        });
      });
    });
  };
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) document.querySelectorAll('[data-jj-film] video').forEach((video) => video.pause());
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
